import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { Routes } from '../routes';

/**
 * Wildcard 404. Centred copy + back-to-dashboard CTA.
 */
export const NotFoundPage = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        textAlign: 'center',
      }}
    >
      <Typography component="h1" variant="h1">
        {t('common.notFound')}
      </Typography>
      <Button component={RouterLink} to={Routes.App.Dashboard} variant="contained">
        {t('common.backToDashboard')}
      </Button>
    </Box>
  );
};
